module.exports = __webpack_public_path__ + "static/media/tv4play.ee7876b1.jpg";